import React, { useEffect, useState } from "react";
import { Home, Search, Ticket, User, Plus, Star } from "lucide-react";
import PanelShell from "../../components/PanelShell";
import { useAuth } from "@/context/AuthContext";
import { clientApi } from "@/lib/clientApi";

const navItems = [
  { to: "/cliente", label: "Inicio", icon: Home, end: true },
  { to: "/cliente/buscar", label: "Buscar", icon: Search },
  { to: "/cliente/historial", label: "Reservas", icon: Ticket },
  { to: "/cliente/perfil", label: "Perfil", icon: User },
];
const bottomNav = [
  { to: "/cliente", label: "Inicio", icon: Home, end: true },
  { to: "/cliente/buscar", label: "Buscar", icon: Search },
  { to: "/cliente/reservar", label: "Reservar", icon: Plus },
  { to: "/cliente/historial", label: "Viajes", icon: Ticket },
  { to: "/cliente/perfil", label: "Perfil", icon: User },
];

const Stars = ({ value, size = 14 }) => (
  <div className="flex items-center gap-0.5" aria-label={`${value} de 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} className={n <= value ? "text-[#C9A227]" : "text-[#2E2F33]"} fill={n <= value ? "currentColor" : "none"} />
    ))}
  </div>
);

const ClientRatings = () => {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    clientApi
      .getRatings()
      .then(({ data }) => setSummary(data))
      .catch(() => setError("No se pudieron cargar tus calificaciones."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PanelShell role="Cliente" navItems={navItems} bottomNavItems={bottomNav} userName={user?.full_name} testId="client-ratings">
      <div className="max-w-4xl mx-auto px-4 lg:px-8 py-8 lg:py-12">
        <p className="text-[10px] uppercase tracking-brand text-[#C9A227] font-display">Reputación</p>
        <h1 className="font-display font-bold text-3xl uppercase tracking-tight mt-1">Tus calificaciones</h1>
        <p className="mt-2 text-sm text-[#A0A0A5] font-body">Lo que los conductores calificaron de tus viajes.</p>

        {error && <p className="mt-4 text-xs text-red-400 font-body">{error}</p>}
        {loading && <p className="mt-5 text-xs text-[#A0A0A5] font-body">Cargando…</p>}

        {!loading && summary && (
          <>
            <div className="mt-8 bg-[#1C1D20] border border-[#2E2F33] rounded-xl p-6 lg:p-8 flex items-center gap-6">
              <div className="text-center shrink-0">
                <p className="font-display font-bold text-4xl text-[#C9A227]">
                  {summary.rating_average != null ? summary.rating_average.toFixed(1) : "—"}
                </p>
                {summary.rating_average != null && <Stars value={Math.round(summary.rating_average)} size={16} />}
              </div>
              <div className="border-l border-[#2E2F33] pl-6">
                <p className="text-sm text-[#F5F5F5] font-body">
                  {summary.rating_count} {summary.rating_count === 1 ? "calificación" : "calificaciones"}
                </p>
                <p className="text-xs text-[#A0A0A5] font-body mt-1">De viajes completados.</p>
              </div>
            </div>

            <div className="mt-6 space-y-3">
              {summary.reviews.length === 0 && (
                <p className="text-xs text-[#A0A0A5] font-body">Todavía no tenés calificaciones.</p>
              )}
              {summary.reviews.map((r) => (
                <div key={r.id} className="bg-[#1C1D20] border border-[#2E2F33] rounded-xl p-5" data-testid={`client-review-${r.id}`}>
                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <Stars value={r.rating} />
                    <span className="text-[10px] text-[#A0A0A5] uppercase tracking-wider">{new Date(r.creado_en).toLocaleDateString("es-PE")}</span>
                  </div>
                  {r.comment && <p className="text-xs text-[#A0A0A5] font-body mt-2">{r.comment}</p>}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </PanelShell>
  );
};

export default ClientRatings;
